module.exports = __webpack_public_path__ + "static/media/partner-story-ad1.3a3ea497.jpg";